import React, { useState } from 'react';
import Title from '../../atoms/title/title.js';

const Input = ({ title, value, type, description, disabled, error, leftIcon, rightIcon, maxLength, placeholder, lines, onChange, onKeyDown, onClick }) => {
    const [text, setText] = useState("");
    const [textLength, setTextLength] = useState("");
    const characterCount = textLength.length;
    const className = () => {
        if (error)
            return "mbw-input-error";
        return null;
    };
    const inputRef = React.useRef(null);
    const handleChange = (event) => {
        const newText = event.target.value;
        setText(newText);
        onChange && onChange(event);
    };
    const handleTextareaChange = (e) => {
        setTextLength(e.target.value);
    };
    return (React.createElement("div", null,
        React.createElement("label", null,
            React.createElement(Title, { fontStyle: "content-small", bold: true }, title)),
        React.createElement("div", { className: "mbw-input-wrapper" }, !lines || lines <= 1 ? (React.createElement(React.Fragment, null,
            leftIcon && React.createElement("div", { className: "mbw-left-icon" }, leftIcon),
            React.createElement("input", { className: `mbw-input ${className()}`, maxLength: maxLength, placeholder: placeholder || "Text", value: value || text, onChange: handleChange, ref: inputRef, disabled: disabled, "aria-label": title, "data-testid": title, tabIndex: 0, type: type || "text", onKeyDown: onKeyDown, onClick: onClick }),
            rightIcon && React.createElement("div", { className: "mbw-right-icon" }, rightIcon))) : (React.createElement("div", { className: "mbw-text-area-wrapper" },
            React.createElement("textarea", { tabIndex: 0, placeholder: placeholder || "Text", onChange: handleTextareaChange, className: `mbw-input ${error && "mbw-text-area-error"}`, disabled: disabled, name: title, rows: lines, maxLength: maxLength || 250 }),
            React.createElement("div", { className: !error ? "mbw-text-area-characters" : "mbw-text-area-characters-error" },
                React.createElement(Title, { fontStyle: "caption-1" },
                    characterCount,
                    "/",
                    maxLength || 250))))),
        description && !error && !disabled && (React.createElement("div", { className: "mbw-input-description" },
            React.createElement(Title, { fontStyle: "caption-1" }, description))),
        error && !disabled && (React.createElement("div", { className: "mbw-input-error-text" },
            React.createElement(Title, { fontStyle: "caption-1" }, error)))));
};

export { Input as default };
//# sourceMappingURL=input.js.map
